import { propertyHierarchy } from 'slykit';
import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { InnovationGraphWrapper } from './wrapper';
import { InnovationGraphKnobs } from './knobs';
import { filterProperties } from "slykit";

const flags = [SrsPropertyFlag.Categorical];

export const config = {
  key: "INNOVATION",
  label: 'Innovation',
  icon: 'graph',
  wrapper: InnovationGraphWrapper,
  endpoint: propertyHierarchy,
  Knobs: InnovationGraphKnobs,
  flags: flags,
  createDefaultOptions: () => {
    return {
      options: {
        propertyList: [
          "Category",
          "Title"
        ],
        parameters: {
          maxValues: 1000,
        },
      },
    };
  },
  isValid: (selectedDefinitionName) => {
    return filterProperties(selectedDefinitionName, flags).length >= 2;
  },
};
